import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalNotificationsByManager {
  name: string;
  api_token: string;
}

export interface InternalNotificationsByManagerListInfor {
  errors: unknown;
  internalNotificationsByManager: InternalNotificationsByManager;
  isAuthenticated: boolean;
}

@Module
export default class InternalNotificationsByManagerModule
  extends VuexModule
  implements InternalNotificationsByManagerListInfor
{
  errors = {};
  internalNotificationsByManager = {} as InternalNotificationsByManager;
  isAuthenticated = !!JwtService.getToken();

  get InternalNotificationsByManager() {
    return this.internalNotificationsByManagerListData;
  }

  @Mutation
  [Mutations.INTERNAL_NOTIFICATIONS_BY_MANAGER_LIST_DATA](
    InternalNotificationsByManager
  ) {
    this.internalNotificationsByManagerListData =
      InternalNotificationsByManager;
  }

  @Action
  [Actions.INTERNAL_NOTIFICATIONS_BY_MANAGER_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/internal/thongbaonoibo", payload)
        .then((data) => {
          this.context.commit(
            Mutations.INTERNAL_NOTIFICATIONS_BY_MANAGER_LIST_DATA,
            data
          );
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
